import { observable, action } from 'mobx';
import { getLabSSHkey } from 'services/LabService';

class LabInstructionsStore {
  @observable isTourDisplayed = false;

  @observable isOrientationVideoDisplayed = false;

  @observable sshKey = '';

  @observable status = 'idle';

  @observable labState = '';

  @action toggleTour = () => {
    this.isTourDisplayed = !this.isTourDisplayed;
  };

  @action toggleOrientationVideoDisplayed = () => {
    this.isOrientationVideoDisplayed = !this.isOrientationVideoDisplayed;
  };

  @observable expandedPanels = new Set<string>();

  @action togglePanels = (id: string, expanded: boolean) =>
    expanded ? this.expandedPanels.add(id) : this.expandedPanels.delete(id);

  @action getSSHkey = (userCredential: string, finalState: string) => {
    this.status = 'retrieving';
    return getLabSSHkey(userCredential)
      .then((data: { key: string }) => {
        this.sshKey = data.key;
        this.status = finalState;
      })
      .catch((error: unknown) => {
        this.status = 'error';
        throw error;
      });
  };
}

export default LabInstructionsStore;
